/**
 * Intestazione visibile solo in @media print: documento sintetico, senza chrome UI.
 */
export default function OssPrintDocumentHeader({ kind, title, lines = [] }) {
  return (
    <header className="hidden print:block mb-5 pb-3 border-b-2 border-slate-900">
      <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-600">{kind}</p>
      <h2 className="text-lg font-bold text-slate-900 mt-1">{title}</h2>
      {lines.map((line, i) => (
        <p key={i} className="text-sm text-slate-700 mt-1">{line}</p>
      ))}
    </header>
  );
}
